export default "__VITE_ASSET__Cd7SG2Mx__"